import { render, staticRenderFns } from "./xmyNotReached.vue?vue&type=template&id=5191d4a8&scoped=true&"
import script from "./xmyNotReached.vue?vue&type=script&lang=js&"
export * from "./xmyNotReached.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5191d4a8",
  null
  
)

export default component.exports